export default __webpack_public_path__ + "static/media/Icon-awesome-directions.0fe64d8c.svg";